var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGl = function SvgIconGl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12c-.522 0-12 1.565-12 1.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 12c0 6.628-5.373 12-12 12S0 18.629 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M8.348 17.74a5.74 5.74 0 1 0 0-11.479 5.74 5.74 0 0 0 0 11.479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M2.608 12a5.74 5.74 0 0 1 11.479 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGl;